interface LogoProps { size?: number; wordmark?: boolean; }

export function Logo({ size = 42, wordmark = false }: LogoProps) {
  return (
    <div className="brand-lockup" aria-label="Mazzager">
      <svg className="logo-mark" width={size} height={size} viewBox="0 0 128 128" fill="none" aria-hidden="true">
        <rect width="128" height="128" rx="32" fill="currentColor" />
        <path d="M22 35 56 48 42 58 20 51 38 73 25 97 63 78 78 91 107 97 89 70 105 38 69 55 56 44 91 27 57 32 42 26Z" fill="var(--logo-ink)" stroke="var(--logo-ink)" strokeLinejoin="round" strokeWidth="4" />
        <path d="m44 73 43-35-15 31 18 18-27-10Z" fill="currentColor" />
        <circle cx="88" cy="44" r="3.5" fill="currentColor" />
      </svg>
      {wordmark && <span className="wordmark">MAZZAGER</span>}
    </div>
  );
}

